export default __webpack_public_path__ + "static/bronzeHero-84bcccccc799a2f8b51d3769a02df46c.jpg";